module.exports = __webpack_public_path__ + "videos/video-preview-portraite.f04fa15f942c11581df917433f37e3f5.mp4";


//////////////////
// WEBPACK FOOTER
// ./images/video-preview-portraite.mp4
// module id = 711
// module chunks = 0